// extracted by mini-css-extract-plugin
module.exports = {"leftArr":"Carousel_leftArr__1ULzp","rightArr":"Carousel_rightArr__2tkBh"};